export const INVOICE_MONTH_SELECTOR_FORM_NAME = 'invoiceMonthMelectorForm';

export const NO_ITEMS_TO_INVOICE_ERROR_CODE = 1477652341;
export const NO_ITEMS_TO_INVOICE_GQL_ERROR_CODE = 1636714121;

export const FRONTEND_UNKNOWN_ERROR_CODE = 1;
